<template>
  <div class="page">
    <h2>Follow-ups</h2>

    <div class="card" style="margin-top:12px;">
      <!-- Type switch: Leads / Inquiries -->
      <div class="row" style="gap:8px;align-items:center;margin-bottom:8px;">
        <select class="input" v-model="type" style="width:160px">
          <option value="leads">Leads</option>
          <option value="inquiries">Inquiries</option>
        </select>

        <select class="input" v-model="status" style="width:160px">
          <option value="pending">Pending</option>
          <option value="completed">Completed</option>
        </select>
        <span class="tag" style="background:#f3f4f6;padding:4px 8px;border-radius:6px;font-size:12px;">
          My follow-ups
        </span>

<!-- 
        <select
          v-if="isAdmin"
          v-model="branchId"
          @change="reload"
          class="input"
          style="width:160px"
        >
          <option value="">All Branches</option>
          <option v-for="b in branches" :key="b.id" :value="b.id">{{ b.name }}</option>
        </select> -->

        <!-- Read-only for manager -->
        <!-- <span v-else-if="isManager" class="tag" style="background:#f3f4f6; padding:4px 8px; border-radius:6px; font-size:12px;">
          {{ userBranchName }}
        </span> -->

        <button class="btn small" @click="reload">Refresh</button>
      </div>

      <div v-if="list.length" style="margin-top:10px;">
        <div
          v-for="f in list"
          :key="f.id"
          class="row"
          style="align-items:center; gap:10px; padding:8px 0; border-top:1px solid #2a2f3a"
        >
          <div style="flex:1">
            <div style="font-weight:600;">
              {{ formatDate(f.dueDate) }}
              <span
                class="badge"
                :class="f.leadStatus==='matured' ? 'badge--green' : (f.leadStatus==='dead' ? 'badge--red' : 'badge--blue')"
              >
                {{ f.leadStatus==='matured' ? 'INQUIRY' : (f.leadStatus==='dead' ? 'DEAD' : 'LEAD') }}
              </span>
              <span class="helper mono">ID: {{ f.leadCode || f.leadId }}</span>
            </div>
            <div>{{ f.leadName }}</div>
            <!-- <div class="helper">{{ f.note }}</div> -->
          </div>
          <div class="note-col" v-if="f.note" :title="f.note">
            {{ f.note }}
          </div>

          <router-link
            class="btn secondary"
            :to="{ name:'sales-customer-detail', params:{ id: f.leadId } }"
          >Open</router-link>

          <button v-if="!f.isDone" class="btn" @click="markDone(f)">Mark done</button>
        </div>
      </div>
      <div v-else class="helper" style="margin-top:8px;">No items.</div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'SalesFollowups',
  data() {
    return {
      type: 'leads',      // leads | inquiries
      status: 'pending',  // pending | completed
      list: [],
      branchId:'',
      branches:[],
    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/currentUser'] || {}
    },
    isAdmin() {
      return this.user.role === 'admin'
    },
    isManager() {
      return this.user.role === 'branch_manager'
    },
    userBranchName() {
      return this.user.branchId || ''
    },
    user() { return this.$store.getters['auth/currentUser'] || {} },
    userId() { return this.user.id || this.user.userId || '' },
  },

  async created() {
    if (this.isAdmin) {
      try {
        const { data } = await this.$api.get('/branches')
        this.branches = Array.isArray(data) ? data : []
      } catch (e) {
        console.error('Failed to fetch branches', e)
      }
    }
    await this.reload()
  },

  methods: {
    // SalesFollowups.vue (methods)
    async reload () {
        try {
            if (this.type === 'leads') {
            const { data } = await this.$api.get('/leads')
            const rows = Array.isArray(data) ? data : []
            this.list = rows
              .filter(l =>
                l.status === 'follow_up' &&
                l.followUpDate &&
                String(l.userId) === String(this.userId)     // <-- only mine
              )
              .map(l => ({
                id: `lead-${l.id}`,
                leadId: l.id,
                userId: l.userId,
                dueDate: l.followUpDate,
                note: l.notes || 'Follow-up',
                isDone: 0,
                createdAt: l.createdAt,
                leadName: l.name,
                leadStatus: 'follow_up',
                leadCode: l.leadCode
              }))
              .sort((a,b) => new Date(a.dueDate) - new Date(b.dueDate))
            return
          }

          // inquiries path
          const url = `/followups/${this.type}`
          const { data } = await this.$api.get(url, { params: { status: this.status } })
          const arr = Array.isArray(data) ? data : []
          this.list = arr.filter(f => String(f.userId) === String(this.userId))  // <-- only mine


        } catch (e) {
            console.error('Followups fetch failed', e)
            this.list = []
        }
    },

    async markDone(f) {
      try {
        await this.$api.patch(`/leads/${f.leadId}/followups/${f.id}`, { isDone: 1 })
        await this.reload()
      } catch (e) {
        console.error('Failed to mark done', e)
      }
    },
    formatDate(d) {
      return d ? dayjs(d).format('DD MMM YYYY') : ''
    }
  }
}
</script>

<style scoped>
.badge--green { background:#16a34a; color:#fff; }
.badge--blue  { background:#1d4ed8; color:#fff; }
.badge--red   { background:#dc2626; color:#fff; }
.mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace }
.btn.small { padding:6px 10px; font-size:12px; }


.note-col{
  flex: 1.6;                /* gives notes more room than the left info block */
  font-size: 14px;          /* larger than helper text */
  color: #111827;           /* high-contrast gray-900 */
  display: -webkit-box;     /* 2-line clamp */
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  line-height: 1.25;
}

/* On smaller screens, hide notes column so the row stays clean */
@media (max-width: 780px){
  .note-col{ display: none; }
}

</style>
